/******************************************************************
 * @NAME y.xiang
 * @CREATEDATE 2022/2/28
 * @DESC <>
 * ****************************************************************/
/*如果是视频回放需要传时间参数，如果是实时播放，则不需要，只需传递需要播放的设备信息就行
 *
 *视频播放保留了2中方式（1.通过链接直接缓存资源，2.通过视频服务器请求资源）
 */
import Hls from "hls.js";
import DPlayer from "dplayer";
import SrsSdk from "../../assets/videojs/srs.sdk.js";
import mpegts from "mpegts.js";
var hlsPlayer = null;
var tsPlayer = null;
export default {
  name: "playVideo",
  props: {
    //显示的tab样式
    tabMode: {
      type: Number,
      default: 1
    },
    // 播放视频的模式。默认是回放视屏，1是实时视频 ， -1为普通视频播放
    videoMode: {
      type: Number,
      default: 0
    },
    // 普通视频播放的时候需要传入播放地址
    videoSrc: {
      type: String,
      default: ""
    },
    //可播放视频的列表
    videoDeviceList: {
      type: Array,
      default() {
        return [];
      }
    },
    domId: {
      type: String,
      default: "videojs-video"
    },
    // 回放的时间
    time: {
      type: Number,
      default: 0
    },
    //回放时长一般指的是前后多少秒，默认30秒
    duration: {
      type: Number,
      default: 30
    },
    iconName: {
      //设备图标
      type: String,
      default: "utm-device-camera"
    },
    // 视频的权限codes,若为空数组不限制权限,否则分别传入实时播放和回放的权限code
    videoCodes: {
      type: Array,
      default() {
        return [];
      }
    },
    simpleMode: {
      type: Boolean,
      default: true
    },
    isFaceDetection: {
      //抓拍报表标识
      type: Boolean,
      default: false
    }
  },
  watch: {
    videoDeviceList: {
      handler(nv, ov) {
        if (nv.length === ov.length) {
          return false;
        }
        this.changeTab(this.videoMode);
      }
    }
  },
  data() {
    return {
      videoApi: window.g.VIDEO_ROOT,
      videoTabIndex: 0,
      videoDeviceInfo: {
        //默认参数
        deviceId: "", //必传，作为播放地址
        deviceName: "",
        accessSiteType: "",
        mapName: ""
      },
      videoSrcUrl: "",
      myPlayer: null,
      playbackTime: null,
      videoDeviceIndex: 0,

      //视频流的播放方式
      backPlayer: { url: null, dp: null },
      backHls: null,
      liveVideoDp: { url: null, dp: null }, //实时视频
      loadingVideoUrl: false,
      videoDom: null,
      // 添加视频下载功能
      downloadInfo: {
        name: "",
        startTime: 0,
        endTime: 0,
        cameraIds: []
      },
      downloadFileModal: false
    };
  },
  beforeDestroy() {
    this.closePlayer();
  },
  mounted() {
    this.changeTab(this.videoMode);
  },
  methods: {
    downLoadFile: function() {
      this.downloadInfo.cameraIds = [];
      let timeStr = this.moment(this.playbackTime - 30000, "x").format(
        "YYYYMMDDHHmmss"
      );
      this.downloadInfo.name = "Video" + timeStr;
      this.downloadInfo.startTime = this.playbackTime - 30000;
      this.downloadInfo.endTime = this.playbackTime + 30000;
      this.downloadInfo.cameraIds = this.videoDeviceList
        .filter(device => {
          return device.canPlayBackVideo;
        })
        .map(device => {
          return device.deviceId;
        });
      console.log(333, this.videoDeviceList, 444, this.downloadInfo.cameraIds);

      this.downloadFileModal = true;
    },
    //确认下载视频
    confirmDownload: function() {
      let _this = this;
      _this.$validator.validateAll("downloadInfo").then(result => {
        if (result) {
          _this.$ajax
            .post("VideoRecord/Create", _this.downloadInfo)
            .then(function(res) {
              if (res.data.success) {
                _this.messageNotice("success");
                _this.downloadFileModal = false;
              } else {
                _this.messageNotice("error", res.data.message);
              }
            });
        }
      });
    },
    changeTab: function(i) {
      this.videoTabIndex = i;
      if (this.videoDeviceList.length) {
        this.changeVideoDevice(this.videoDeviceList[this.videoDeviceIndex]);
      }
    },
    palyVideoUrl: function(url) {
      this.closePlayer();
      this.videoSrcUrl = url;
      this.createPlayer();
      this.videoTabIndex = -1;
    },
    //释放视频资源
    closePlayer: function() {
      if (tsPlayer) {
        tsPlayer.destroy();
        tsPlayer = null;
      }
      if (hlsPlayer) {
        hlsPlayer.destroy();
        hlsPlayer = null;
      }
      if (this.myPlayer) {
        // this.myPlayer.pause();
        this.myPlayer.removeAttribute("src"); // empty source
        this.myPlayer.load();
      }
      if (this.backPlayer && this.backPlayer.dp && this.tabMode !== -1) {
        this.backPlayer.dp.destroy();
      }
      if (this.backHls) {
        this.backHls.destroy();
      }
      if (this.liveVideoDp && this.liveVideoDp.dp && this.tabMode !== -1) {
        this.liveVideoDp.dp.close();
      }
    },
    //创建视频资源
    createPlayer: function() {
      if (!this.myPlayer) {
        this.myPlayer = document.getElementById("deviceVideo");
      }
    },
    //切换设备
    changeDevice: function(index) {
      this.videoDeviceIndex = index;
      this.changeVideoDevice(this.videoDeviceList[this.videoDeviceIndex]);
    },
    //切换播放视频源
    changeVideoDevice: function(data, time) {
      console.log(data);
      // 如果播放的不是同一段视频则需要清空播放器从新播放
      if (
        this.videoTabIndex === 0 &&
        this.videoDeviceInfo.deviceId &&
        this.videoDeviceInfo.deviceId !== data.deviceId
      ) {
        this.backPlayer.dp = null;
        this.liveVideoDp.dp = null;
      }
      if (
        this.videoTabIndex === 0 &&
        time &&
        this.playbackTime &&
        this.playbackTime !== time
      ) {
        this.backPlayer.dp = null;
      }
      if (
        this.videoTabIndex === 1 &&
        this.videoDeviceInfo.deviceId &&
        this.videoDeviceInfo.deviceId !== data.deviceId
      ) {
        this.liveVideoDp.dp = null;
        this.backPlayer.dp = null;
      }
      this.videoDeviceInfo = data;
      if (!this.videoDeviceInfo.deviceId) {
        return false;
      }
      //切换需要释放资源不然会造成内存泄漏
      if (this.videoTabIndex !== 1) {
        if (time) {
          this.playbackTime = time / 1;
        } else {
          this.playbackTime = this.time / 1;
        }
      }
      if (typeof this.videoDeviceInfo.accessSiteType === "number") {
        this.videoDeviceInfo.direction = this.common.deviceDirection[
          this.videoDeviceInfo.accessSiteType
        ].label;
      } else {
        this.videoDeviceInfo.direction = "-";
      }
      if (this.ApiService.videoDockMode === 2) {
        //实时播放
        if (this.videoTabIndex === 1 && !this.liveVideoDp.dp) {
          this.getLiveVideoUrl();
        } else if (
          this.videoTabIndex === 0 &&
          this.playbackTime &&
          !this.backPlayer.dp
        ) {
          //回放视频
          this.getBackVideoUrl();
        } else if (
          (this.videoTabIndex === 0 || this.videoTabIndex === -1) &&
          this.playbackTime &&
          this.backPlayer.dp
        ) {
          //如果视频已经连接不需要重新请求地址，直接播放
          this.backPlayer.dp.seek(0);
        }
      } else {
        let videoSrcUrl = "";
        //实时播放
        if (this.videoTabIndex === 1) {
          videoSrcUrl =
            this.videoApi + "Media/LiveStream/" + this.videoDeviceInfo.deviceId;
        } else if (this.videoTabIndex === 0 && this.playbackTime) {
          //回放视频
          palyTime = this.playbackTime;
          videoSrcUrl =
            this.videoApi +
            "Media/PlaybackStream/" +
            this.videoDeviceInfo.deviceId +
            "?startTime=" +
            (palyTime - this.duration * 1000) +
            "&endTime=" +
            (palyTime + this.duration * 1000);
        }
        if (!videoSrcUrl) {
          return;
        }
        this.videoSrcUrl = videoSrcUrl;
        this.createPlayer();
      }
    },

    handleVideoStop: function() {
      this.$emit("videoEnded", true);
    },

    /* *******************************视频视频服务器来播放视频 先关逻辑************************************* */

    //获取回放地址
    getBackVideoUrl: function() {
      let _this = this;

      let palyTime = this.playbackTime;
      let param = {
        cameraId: _this.videoDeviceInfo.deviceId,
        startTime: palyTime - window.g.BACK_VIDEO_START * 1000,
        endTime: palyTime + window.g.BACK_VIDEO_END * 1000,
        type: 2
      };
      this.$ajax
        .post("Media/Video", param, {
          baseURL: _this.videoApi,
          headers: { noLoading: true }
        })
        .then(res => {
          if (res.data.success) {
            let url =
              window.g.BACK_VIDEO_ROOT +
              "playback/" +
              res.data.data.address +
              "/index.m3u8?token=" +
              res.data.data.token;
            _this.backPlayer.url = url;
            _this.$nextTick(() => {
              _this.playBackVideo();
              _this.loadingVideoUrl = false;
            });
          } else {
            _this.loadingVideoUrl = false;
          }
        })
        .catch(() => {
          _this.loadingVideoUrl = false;
        });
    },
    playBackVideo: function() {
      var video = document.getElementById("playbackVideo");
      hlsPlayer = new Hls({
        enableWorker: true, // Improve performance and avoid lag/frame drops.
        lowLatencyMode: true, // Enable Low-Latency HLS part playlist and segment loading.
        liveSyncDurationCount: 50, // Start from the last few segments.
        liveMaxLatencyDurationCount: 51, // Maximum delay allowed from edge of live.
        maxBufferLength: 8, // Maximum buffer length in seconds.
        maxMaxBufferLength: 10, // The max Maximum buffer length in seconds.
        maxLiveSyncPlaybackRate: 1.2, // Catch up if the latency is large.
        liveDurationInfinity: true // Override current Media Source duration to Infinity for a live broadcast.
      });
      hlsPlayer.loadSource(camera.backUrl);
      hlsPlayer.attachMedia(video);
      video.play();
    },

    //首先根据设备的id获取视频的播放地址和token
    getLiveVideoUrl: function() {
      let _this = this;
      this.loadingVideoUrl = true;
      let param = {
        cameraId: this.videoDeviceInfo.deviceId,
        startTime: 0,
        endTime: 0,
        type: 1
      };
      this.$ajax
        .post("Media/Video", param, {
          baseURL: _this.videoApi,
          headers: { noLoading: true }
        })
        .then(res => {
          if (res.data.success) {
            let url =
              window.g.LIVE_VIDEO_ROOT +
              "live/" +
              res.data.data.address +
              ".ts?token=" +
              res.data.data.token;
            this.liveVideoDp.url = url;
            this.liveVideoDp.dp = null;
            this.$nextTick(() => {
              this.playLiveVideo();
              this.loadingVideoUrl = false;
            });
          } else {
            this.loadingVideoUrl = false;
          }
        })
        .catch(() => {
          this.loadingVideoUrl = false;
        });
    },
    playLiveVideo: function() {
      if (mpegts.getFeatureList().mseLivePlayback) {
        var videoElement = document.getElementById("liveVideo");
        tsPlayer = mpegts.createPlayer({
          type: "mpegts",
          isLive: true,
          url: this.liveVideoDp.url,
          enableStashBuffer: false
        });
        tsPlayer.attachMediaElement(videoElement);
        tsPlayer.load();
        tsPlayer.play();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/utmPlayVideo.js